import { createSelector } from 'reselect';

import {
    whoisByDomainSelector,
} from '../common/selectors/whois-selectors';
import {
    modalAttributesSelector
} from '../common/selectors/modal-selectors';

export const whoisDataForDomainModalSelector = createSelector(
    whoisByDomainSelector,
    modalAttributesSelector,
    ( whoisDataByDomains, modalAttributes ) => {
        const domain = modalAttributes.domain;

        return whoisDataByDomains[domain] || '';
    }
);

export const whoisModalDomainSelector = createSelector(
    modalAttributesSelector,
    ( modalAttributes ) => {
        return modalAttributes.domain || '';
    }
);
